import React from 'react';
import { ManualPaymentDialog } from './PaymentMethodModal';

const PredictionPaymentModal = ({ isOpen, onClose }) => (
  <ManualPaymentDialog
    isOpen={isOpen} onClose={onClose}
    title="Una predicción premium" amount={25}
    endpoint="/prediction/purchase/zelle"
  />
);

export default PredictionPaymentModal;
